var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _vm.isAgent
      ? _c("section", [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 col-xs-12" }, [
                _c("label", { staticClass: "inbox-label required" }, [
                  _vm._v(_vm._s(_vm.t("application.agent"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: {
                    fieldTitle: _vm.t("application.agent", {}, "zh"),
                    fieldname: "agent",
                    required: "",
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 col-xs-12" }, [
                _c("label", { staticClass: "inbox-label" }, [
                  _vm._v(_vm._s(_vm.t("application.remark"))),
                ]),
                _vm._v(" "),
                _c("textarea", {
                  staticClass: "form-control",
                  staticStyle: { "max-width": "100%" },
                  attrs: {
                    fieldTitle: _vm.t("application.remark", {}, "zh"),
                    fieldname: "remark",
                  },
                }),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "required" }, [
          _c("span", [_vm._v(_vm._s(_vm.t("application.contact_time")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 col-md-6 col-xs-12" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedDate,
                    expression: "selectedDate",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "today",
                  name: "contact_date",
                  required: "",
                },
                domProps: { checked: _vm._q(_vm.selectedDate, "today") },
                on: {
                  change: [
                    function ($event) {
                      _vm.selectedDate = "today"
                    },
                    _vm.contactDateChange,
                  ],
                },
              }),
              _vm._v(_vm._s(_vm.t("common.today")) + "  \n            "),
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedDate,
                    expression: "selectedDate",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "tomorrow",
                  name: "contact_date",
                  required: "",
                },
                domProps: { checked: _vm._q(_vm.selectedDate, "tomorrow") },
                on: {
                  change: [
                    function ($event) {
                      _vm.selectedDate = "tomorrow"
                    },
                    _vm.contactDateChange,
                  ],
                },
              }),
              _vm._v(_vm._s(_vm.t("common.tomorrow")) + "  \n            "),
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedDate,
                    expression: "selectedDate",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "custom",
                  name: "contact_date",
                  required: "",
                },
                domProps: { checked: _vm._q(_vm.selectedDate, "custom") },
                on: {
                  change: [
                    function ($event) {
                      _vm.selectedDate = "custom"
                    },
                    _vm.contactDateChange,
                  ],
                },
              }),
              _vm._v(_vm._s(_vm.t("common.other_date")) + "\n            "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedDate === "custom",
                  expression: "selectedDate === 'custom'",
                },
              ],
              staticClass: "form-control datepicker",
              attrs: {
                name: "custom_date",
                required: "",
                type: "text",
                placeholder: "yyyy-mm-dd",
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6 col-md-6 col-xs-12 time-section" },
            [
              _c("label", [_vm._v(_vm._s(_vm.t("application.contact_from")))]),
              _vm._v(" \n            "),
              _c("v-select", {
                attrs: {
                  options: _vm.timeOptions,
                  reduce: (option) => option.code,
                  searchable: false,
                  name: "contact_from",
                  required: "",
                },
                model: {
                  value: _vm.startTime,
                  callback: function ($$v) {
                    _vm.startTime = $$v
                  },
                  expression: "startTime",
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v(_vm._s(_vm.t("application.contact_to")))]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  options: _vm.timeOptions,
                  reduce: (option) => option.code,
                  searchable: false,
                  name: "contact_to",
                  required: "",
                },
                model: {
                  value: _vm.endTime,
                  callback: function ($$v) {
                    _vm.endTime = $$v
                  },
                  expression: "endTime",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "hidden",
            fieldTitle: _vm.t("application.contact_time", {}, "zh"),
            fieldname: "contactTime",
            name: "contact_time",
          },
        }),
        _vm._v(" "),
        _c("small", { staticStyle: { "margin-top": "10px" } }, [
          _vm._v(_vm._s(_vm.t("application.contact_tips"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        staticStyle: {
          "max-height": "300px",
          "overflow-y": "auto",
          padding: "10px 0px",
        },
      },
      [
        _c("small", {
          domProps: {
            innerHTML: _vm._s(
              _vm.t("application.terms", { companyName: _vm.companyName })
            ),
          },
        }),
        _vm._v(" "),
        _vm.checkTu
          ? _c("small", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.t("application.tu_terms", {
                    companyName: _vm.companyName,
                  })
                ),
              },
            })
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group text-right col-xs-12" }, [
      _c("label", { staticClass: "col-form-label" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.t("application.agree_terms")) + "\n        "
        ),
        _c("input", {
          attrs: {
            type: "checkbox",
            name: "terms",
            value: "agree",
            required: "",
          },
          domProps: { checked: _vm.aggred },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }